import './registerServiceWorker';
import Vue from 'vue';
import VueRouter from 'vue-router';

import auth from '@websanova/vue-auth/src/v2.js';
import driverAuthBearer from '@websanova/vue-auth/src/drivers/auth/bearer.js';
import driverHttpAxios from '@websanova/vue-auth/src/drivers/http/axios.1.x.js';
import driverRouterVueRouter from '@websanova/vue-auth/src/drivers/router/vue-router.2.x.js';

import './plugins';
import './plugins/global-components';

import axios from 'axios';
import VueAxios from 'vue-axios';

import store from './plugins/store';
import App from './App.vue';

import './scss/style.scss';

import { routes } from './router/index';
import i18n from './i18n';
import { applyPageSeo } from './seo/applySeo';
import { isInAppWebView, persistWebViewFromQuery } from '@/libs/isInAppWebView';

Vue.use(VueAxios, axios);
Vue.use(VueRouter);

window.axios = axios;
window.moment = require('moment');

// Set the base URL for Axios
axios.defaults.baseURL = 'https://slot.kob88.site/api';
// axios.defaults.baseURL = 'http://kob-api.test/api/';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const authToken = localStorage.getItem('token');
if (authToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
}

const DEFAULT_REFERRAL_CODE = 'RYWPCH';

function ensureDefaultReferralCode() {
  const existing = localStorage.getItem('referralCode');
  if (!existing || !String(existing).trim()) {
    localStorage.setItem('referralCode', DEFAULT_REFERRAL_CODE);
  }
}

// Generate and persist device_uuid if not present (used by navbar / login quick-login)
if (!localStorage.getItem('device_uuid')) {
  const deviceUuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
  localStorage.setItem('device_uuid', deviceUuid);
}

ensureDefaultReferralCode();
persistWebViewFromQuery();
if (isInAppWebView()) {
  document.documentElement.classList.add('in-app-webview');
}
store.commit('setInAppWebView', isInAppWebView());

// Set up the VueRouter instance
const router = new VueRouter({
  mode: 'history',
  routes,
  // linkExactActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }; // Scroll to the top on every route change
  }
});

// Before each route: persist referral `code` from URL; keep `referrer` / `code` in the query chain
router.beforeEach((to, from, next) => {
  const persistReferralCode = (raw) => {
    if (raw == null) return;
    const c = String(raw).trim();
    if (c) {
      localStorage.setItem('referralCode', c);
    }
  };

  persistReferralCode(to.query.code);
  const routeSearch = Object.keys(to.query).length
    ? `?${new URLSearchParams(to.query).toString()}`
    : null;
  persistWebViewFromQuery(routeSearch);
  store.commit('setInAppWebView', isInAppWebView());

  const query = { ...to.query };
  let changed = false;

  if (from.query.referrer && !to.query.referrer) {
    query.referrer = from.query.referrer;
    changed = true;
  }
  if (from.query.code && !to.query.code) {
    query.code = from.query.code;
    changed = true;
    persistReferralCode(from.query.code);
  }

  ensureDefaultReferralCode();

  if (changed) {
    next({
      path: to.path,
      query,
      hash: to.hash,
      replace: true,
    });
  } else {
    next();
  }
});

router.afterEach((to) => {
  const merged = to.matched.reduce(
    (acc, record) => ({ ...acc, ...(record.meta || {}) }),
    {}
  );
  applyPageSeo(
    {
      title: merged.title,
      description: merged.description,
      keywords: merged.keywords,
      robots: merged.robots,
    },
    to.fullPath
  );
});

// Use the VueAuth plugin
Vue.use(auth, {
  plugins: {
    http: Vue.axios,
    router,
  },
  drivers: {
    auth: driverAuthBearer,
    http: driverHttpAxios,
    router: driverRouterVueRouter,
  },
  options: {
    loginData: {
      url: 'auth/login',
      method: 'POST',
    },
    registerData: {
      url: 'auth/register',
      method: 'POST',
    },
    fetchData: {
      url: 'auth/user',
      method: 'GET',
    },
    authRedirect: {
      path: '/auth/login',
    },
  },
});

Vue.config.productionTip = false;

// Initialize the Vue instance
const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: (h) => h(App)
});
